import { render, staticRenderFns } from "./DestinationRule.vue?vue&type=template&id=0ba34692&"
import script from "./DestinationRule.vue?vue&type=script&lang=js&"
export * from "./DestinationRule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports